import React, { useEffect, useLayoutEffect } from 'react';
import { Image, ScrollView, StyleSheet, TouchableOpacity, View } from 'react-native';
import Button from '../../components/Button';
import BaseText from '../../components/BaseText';
import { CommonStyles, Color, CommonProperties } from '../../styles';
import { AAServiceTypes } from '../../constants/Enums';
import { useSelector } from 'react-redux';
import { rightLoginHeaderOption } from '../../utils/defaultNavOptions';
import { Screens } from '../../constants/ScreenNames';
import { getAAToken } from '../../store/actions/auth';

export const getAAServiceTypeOptions = (user) => {
  const isLeisureAllowed = user?.IsLeisureAllowed;
  const bannedOption = isLeisureAllowed ? AAServiceTypes.CORPORATE_TRAVEL : AAServiceTypes.LEISURE;
  return Object.values(AAServiceTypes).filter((option) => option !== bannedOption);
};

const AAHomeScreen = (props) => {
  const { navigation } = props;
  const user = useSelector((state) => state && state.auth && state.auth.user);
  const isLeisureAllowed = user?.IsLeisureAllowed;
  const optionText = isLeisureAllowed
    ? AAServiceTypes.LEISURE.text
    : AAServiceTypes.CORPORATE_TRAVEL.text;
  const navigateToHome = (serviceType) => {
    navigation.navigate(Screens.AASearchScreen, { serviceType });
  };

  useLayoutEffect(() => {
    if (user) {
      return;
    }
    props.navigation.setOptions({
      headerTitleAlign: 'left',
      ...rightLoginHeaderOption(props.navigation),
    });
  }, []);

  useEffect(() => {
    (async () => {
      if (!user) {
        await getAAToken();
      }
    })();
  }, []);

  return (
    <View style={CommonStyles.flex1}>
      <ScrollView contentContainerStyle={styles.scrollViewContainer}>
        <View>
          <Image style={styles.bannerImg} source={require('../../assets/home.jpg')} />
        </View>
        {user && (
          <View style={CommonProperties.centerAlignment}>
            <BaseText style={CommonProperties.h3}>
              Welcome {user.FirstName} {user.LastName}
            </BaseText>
            <BaseText style={CommonProperties.h3}>{user.GroupName}</BaseText>
          </View>
        )}
        <View style={styles.row}>
          <TouchableOpacity
            style={[styles.flewRow, styles.borderBottom, CommonProperties.centerAlignment]}
            onPress={() => {
              navigateToHome(optionText);
            }}
          >
            <BaseText style={CommonStyles.h3}>{optionText}</BaseText>
          </TouchableOpacity>
          <TouchableOpacity
            style={[
              styles.flewRow,
              styles.borderLeft,
              styles.borderBottom,
              CommonProperties.centerAlignment,
            ]}
            onPress={() => {
              navigateToHome(AAServiceTypes.BUSINESS_EXTRA.text);
            }}
          >
            <BaseText style={CommonStyles.h3}>{AAServiceTypes.BUSINESS_EXTRA.text}</BaseText>
          </TouchableOpacity>
        </View>

        <View style={styles.row}>
          <TouchableOpacity style={[styles.flewRow, CommonProperties.centerAlignment]}>
            <BaseText style={CommonStyles.h3}>View Itinerary</BaseText>
          </TouchableOpacity>
        </View>

        <View>
          <Image style={styles.bxImg} source={require('../../assets/bx.jpg')} />
        </View>
        <View style={styles.paragraph}>
          <BaseText style={[CommonStyles.h3, CommonStyles.mb3]}>
            Our Reward Program for Businesses
          </BaseText>
          <BaseText style={[CommonStyles.h4, CommonStyles.mb3]}>
            Business extra helps reduce travel costs and gives more perks to the people that matter.
            It's free to join and you'll enjoy the benefits right away.
          </BaseText>
          <BaseText style={[CommonStyles.h4, CommonStyles.mb3]}>
            Your employees earn AAdvantage® miles and your business earns points to use for:
          </BaseText>
          <BaseText style={CommonStyles.h4}>{`- Flights (for work or to give as a gift)`}</BaseText>
          <BaseText style={CommonStyles.h4}>- First and Business Class Upgrades</BaseText>
        </View>
      </ScrollView>
    </View>
  );
};

const styles = StyleSheet.create({
  scrollViewContainer: {
    flexGrow: 1,
    backgroundColor: Color.background,
  },
  bannerImg: {
    height: 220,
    resizeMode: 'contain',
  },
  bxImg: {
    height: 300,
    resizeMode: 'contain',
  },
  paragraph: {
    ...CommonProperties.p4,
  },
  row: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
    ...CommonProperties.px3,
  },
  flewRow: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    ...CommonProperties.py3,
  },
  borderLeft: {
    borderLeftWidth: 0.7,
    borderLeftColor: 'rgba(0,0,0,.2)',
  },
  borderBottom: {
    borderBottomWidth: 0.7,
    borderBottomColor: 'rgba(0,0,0,.2)',
  },
});

export default AAHomeScreen;
